import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 対象 */
enum Target {
  yes = '1',
  no = '2',
}

const nameConfig = {
  yes: new Map([
    [Locale.ja, '対象'],
    [Locale.en, 'target'],
  ]),
  no: new Map([
    [Locale.ja, '対象外'],
    [Locale.en, 'not target'],
  ]),
};

const toEnum = rawValueToEnum(Target, Target.yes);
const toDisplay = enumToName(Target, nameConfig);
const toDisplayWithPrefix = enumToName(Target, nameConfig, { prefix: true });

export const target = {
  enum: Target,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { Target };
